import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import logger from "../../../../utils/LoggerFrontend";
import { CustomerSucessController, Button as BtnPrimary } from "@talentbait/shared-components";
import { CampaignCreationStore, withRefluxStore } from "../../../../Stores";
import {
  BookNewSection,
  ConfirmationBanner,
  Heading,
  StepOne,
  WhatsNextContent,
  StepTwo,
  TextBox,
  StepThree
} from "./BookingFinished.styled";
import { ExitArrowIcon, TickIcon } from "../../../../Components/Icons";
import { Collapse } from "../../../../Components/Layout";
import { CollapseHeader } from "./CollapseHeader";
import { FinishedView } from "./BookingFinished.styled";
import { BannerText } from "./BannerText";
import { useTranslation } from "react-i18next";

const BookingFinished = ({
  campaignId,
  // Store
  userProfile,
  isFirstCampaign,
  // Router
  history
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState({
    adPreview: true,
    campaign: false,
    learning: false
  });

  useEffect(() => {
    logger.debug("BookingFinished", "page rendered...");
    CustomerSucessController.send(`NewCmapaign:Finished`);
  }, []);

  logger.debug("BookingFinished:render", "called...", userProfile);

  const goToCampaign = () => history.push(`/campaign/${userProfile.organizationId}/${campaignId}`);

  return (
    <FinishedView
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <ConfirmationBanner>
        <p>{t("BOOKING CONFIRMATION")}</p>
        <a href="/dashboard">{t("BACK TO DASHBOARD")}</a>
      </ConfirmationBanner>
      <Heading>
        <TickIcon />
        <div>
          <BannerText isFirstCampaign={isFirstCampaign} />
          <p>{t("The booking is complete. This is what happens next for you")}:</p>
        </div>
      </Heading>
      <WhatsNextContent>
        <Collapse
          parent={
            <CollapseHeader
              id="adPreview"
              setShow={setShow}
              active={show.adPreview}
              text={`1. ${t("Waiting for the ad preview")}`}
            />
          }
          show={show.adPreview}
        >
          <StepOne>
            <img src="/images/CampaignFinishPhones.png" alt="step one ad preview" />
            <TextBox>
              <h2>{t("WAITING FOR AD PREVIEW")}</h2>
              <div>
                <p>
                  {t(
                    "Our campaign managers will send you the optimized ad preview and further recommendations for action shortly."
                  )}
                </p>
                <BtnPrimary type="primary" size="large" width="50%" onClick={goToCampaign}>
                  {t("To the campaign")}
                </BtnPrimary>
              </div>
            </TextBox>
          </StepOne>
        </Collapse>

        <Collapse
          parent={
            <CollapseHeader
              id="campaign"
              setShow={setShow}
              active={show.campaign}
              text={`2. ${t("Release of the campaign")}`}
              tooltip={t(
                "You don't see any metrics after approval? Don't worry! During the first 48 hours after approval, the ads are reviewed and then displayed."
              )}
            />
          }
          show={show.campaign}
        >
          <StepTwo>
            <img
              src="/images/campaign-creation/booking-finished-text.png"
              alt="step two campaign"
            />
            <TextBox>
              <h2>{t("RELEASE OF THE CAMPAIGN")}</h2>
              <p>
                {t(
                  "After you have received the ad preview, you can make changes yourself or activate the campaign directly."
                )}
              </p>
            </TextBox>
          </StepTwo>
        </Collapse>

        <Collapse
          parent={
            <CollapseHeader
              id="learning"
              setShow={setShow}
              active={show.learning}
              text={`3. ${t("Learning phase of the channels for performance optimization")}`}
              tooltip={
                <>
                  {t("The")} <strong>{t("Learning phase")}</strong>{" "}
                  {t(
                    "lasts up to 10 days after the campaign starts. During the learning phase, different ad formats are tested to identify what the target group responds to. During this time, we do not make any changes to the campaign, otherwise the learning phase begins again."
                  )}
                </>
              }
            />
          }
          show={show.learning}
        >
          <StepThree>
            <img
              src="/images/campaign-creation/booking-finished-graph.png"
              alt="step two campaign"
            />
            <TextBox>
              <h2>{t("LEARNING PHASE OF THE CHANNELS FOR PERFORMANCE OPTIMIZATION")}</h2>
              <p>
                {t(
                  "After the campaign has been reviewed (on the channels), the learning phase begins. Over the next 7 to 10 days, the ad content is tested for its attractiveness to the target group. The campaign is optimized based on these findings."
                )}
              </p>
            </TextBox>
          </StepThree>
        </Collapse>
      </WhatsNextContent>

      <BookNewSection href="/new-campaign">
        <ExitArrowIcon />
        <p>{t("Book another campaign")}</p>
      </BookNewSection>
    </FinishedView>
  );
};

export default withRouter(
  withRefluxStore(BookingFinished, [CampaignCreationStore], ["userProfile", "isFirstCampaign"])
);
